// extracted by mini-css-extract-plugin
module.exports = {"button":"PreviousButton_button___l7Sf","sr":"PreviousButton_sr__TNBDk"};